const AdminRole = {
  EDITOR: 1,
  FINANCE: 2,
  TECHNICAL: 3,
  ADMIN_AD_MANAGE: 4,
  ADMIN_AD_SPECIAL: 10,
  ADMIN_AD_BUSINESS: 11,
  ADMIN_AD_FINNANCE: 12,
  ADMIN_AD_SUPER: 13,
  ADMIN_SUPER: 100
}

export default AdminRole



// WEBPACK FOOTER //
// ./src/utils/auth.js